var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#5FC9E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9707 55.168L34.2267 21.3493C34.2653 21.0989 34.3816 20.8669 34.5593 20.6862C34.737 20.5056 34.967 20.3853 35.2168 20.3426C35.4665 20.2998 35.7234 20.3367 35.9511 20.448C36.1788 20.5593 36.3657 20.7393 36.4854 20.9627L42.1387 31.5733L28.9707 55.168ZM66.3067 63.3733L61.3014 32.2507C61.2637 32.0329 61.1671 31.8295 61.022 31.6627C60.877 31.4959 60.6891 31.372 60.4786 31.3044C60.2681 31.2368 60.0432 31.2281 59.8281 31.2793C59.6131 31.3304 59.4161 31.4395 59.2587 31.5947L27.6934 63.3733L45.16 73.216C46.256 73.8293 47.592 73.8293 48.688 73.216L66.3067 63.3733ZM52.112 36.2133L48.0667 28.472C47.9644 28.2777 47.811 28.115 47.623 28.0015C47.435 27.888 47.2196 27.828 47 27.828C46.7804 27.828 46.565 27.888 46.377 28.0015C46.189 28.115 46.0356 28.2777 45.9334 28.472L28.1707 60.304L52.112 36.2133Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.e0d5a372afbffcf8a12a91053a9e4a79.svg";
export { ForwardRef as ReactComponent };